import { useNavigate } from "react-router-dom";
import moment from "moment"

import sortIcon from "../../../assets/images/sort.svg"
import viewProfile from "../../../assets/images/viewProfile.svg"

import { useAuth } from "../../../context/auth-user"
import { useClientsTable } from "../hooks/useClientsTable"

export function ClientsTable({
    onSortChange,
}) {
    const navigate = useNavigate();
    
    const { user } = useAuth()
    const userLogged = user?.selectedProfile
    const darkLightMode = userLogged?.darkLightMode

    const mainStyle = {
		background: darkLightMode ? "#131E29" : "white",
		color: darkLightMode ? "white" : "inherit"
	}
    
    const {
        data: allClients,
        isFetching
    } = useClientsTable()
    
    const handleSortChange = (field) => {
        onSortChange?.(field)
    }

    return (
        <>
            <table className={`tableClientsAdminView ${isFetching ? "fetchingData" : ""}`}>
                <thead>
                    <tr>
                        <th style={mainStyle}>
                            <span>Name</span>
                            <img className="sort" src={sortIcon} alt="Prodensa supplier" onClick={() => handleSortChange("name")} />
                        </th>
                        <th style={mainStyle}>
                            <span>Industry</span>
                            <img className="sort" src={sortIcon} alt="Prodensa supplier" onClick={() => handleSortChange("industry")} />
                        </th>
                        <th style={mainStyle}>
                            <span>Location</span>
                            <img className="sort" src={sortIcon} alt="Prodensa supplier" onClick={() => handleSortChange("location")} />
                        </th>
                        <th style={mainStyle}>
                            <span>Status</span>
                            <img className="sort" src={sortIcon} alt="Prodensa supplier" onClick={() => handleSortChange("status")} />
                        </th>
                        <th style={mainStyle}>
                            <span>Registration</span>
                            <img className="sort" src={sortIcon} alt="Prodensa supplier" onClick={() => handleSortChange("createdAt")} />
                        </th>
                        <th style={mainStyle}>
                            <span>Entities</span>
                            <img className="sort" src={sortIcon} alt="Prodensa supplier" onClick={() => handleSortChange("entitiesCount")} />
                        </th>
                    </tr>
                </thead>

                <tbody>
                    {allClients.length === 0 && (
                        <tr>
                            <td colSpan={6} style={{ textAlign: "center", padding: "20px" }}>
                                No clients found.
                            </td>
                        </tr>
                    )}

                    {allClients.map(client => (
                        <tr key={client._id}>
                            <td>
                                <div className="infoContainer">
                                    <span onClick={() => navigate("./clientProfile/" + client._id)}>
                                        {client.name}
                                    </span>
                                </div>
                            </td>

                            <td>
                                <div className="infoContainer">
                                    <span>{client.industries}</span>
                                </div>
                            </td>
                            <td>
                                <div className="infoContainer">
                                    <span>{client.location}</span>
                                </div>
                            </td>
                            <td>
                                <div className="infoContainer">
                                    <span className={`${client.status ? "success" : "failedAlone"}`}>
                                        {client.status ? "Active" : "Disabled"}
                                    </span>
                                </div>
                            </td>
                            <td>
                                <div className="infoContainer">
                                    <span>{moment(client.createdAt).format("DD MMM YYYY")}</span>
                                </div>
                            </td>
                            <td>
                                <div className="infoContainer">
                                    <span>{client.entitiesCount}</span>

                                    <img className="viewProfile" src={viewProfile} alt="Prodensa Supplier" onClick={() => navigate("./clientProfile/" + client._id)} />
                                </div>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>

            <div className="d-lg-none clientList">
                {allClients.length === 0 && (
                    <div style={{ textAlign: "center", padding: "20px" }}>
                        No clients found.
                    </div>
                )}
                
                {allClients.map(client => (
                    <div key={client._id} className="clientRow" onClick={() => navigate("./clientProfile/" + client._id)}>
                        <h5 className="clientName">{client.name}</h5>
                        <div className="clientInformation">
                            <span className="clientValue">{client.location}</span>
                            <span className="clientTitle">Location</span>
                            <span className={`clientValue ${client.status ? "success" : "failedAlone"}`}>
                                {client.status ? "Active" : "Disabled"}
                            </span>
                            <span className="clientTitle">Status</span>
                            <span className="clientValue">{client.industries}</span>
                            <span className="clientTitle">Industry</span>
                            <span className="clientValue">{moment(client.createdAt).format("DD MMM YYYY")}</span>
                            <span className="clientTitle">Registration</span>
                            <span className="clientValue">{client.entitiesCount}</span>
                            <span className="clientTitle">Entities</span>
                        </div>
                    </div>
                ))}
            </div>
        </>
    )
}